import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { LEER } from '../../lib/format';

export interface Angabe {
  /** Name der Angabe in Satzschreibung: „Kundentyp“, „USt-IdNr.“. */
  label: ReactNode;
  /** Leer (`null`, `undefined`, `''`, `false`, oder schon „–“ aus einem Formatierer) erscheint gedämpft als „–“. */
  value: ReactNode;
  /** Nummern, Daten und Beträge: t-mono mit tabellarischen Ziffern. */
  mono?: boolean;
}

export interface AngabenProps {
  items: Angabe[];
  className?: string;
}

const leer = (v: ReactNode) => v === null || v === undefined || v === '' || v === false || v === LEER;

/**
 * Name-Wert-Liste für Stammdaten auf Detailseiten. Jede Angabe steht immer da,
 * eine leere als „–“, damit sichtbar ist, was fehlt. Ist die Liste schmaler als
 * 24rem (Handy, Seitenspalte), steht der Name über dem Wert, sonst daneben;
 * gemessen an der Breite der Liste, nicht des Bildschirms.
 */
export function Angaben({ items, className }: AngabenProps) {
  return (
    <dl className={cn('@container flex flex-col gap-3', className)}>
      {items.map((a, i) => (
        <div key={i} className="grid gap-0.5 @sm:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] @sm:items-baseline @sm:gap-4">
          <dt className="t-label text-muted-foreground">{a.label}</dt>
          <dd className={cn('min-w-0 break-words', a.mono && 't-mono tabular', leer(a.value) && 'text-muted-foreground')}>
            {leer(a.value) ? LEER : a.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
